import { ElementData, ElementDataValue, FormElement } from '../../lib/types'
import ChangeIndicator from './change-indicator'
import { DatePicker, DatePickerInput, Tooltip } from '@carbon/react'
import { Information } from '@carbon/icons-react'
import dayjs from 'dayjs'
import { getCaseInsensitive } from '../../lib/get-id'

type Props = {
    original: ElementData
    data: ElementData
    prevData?: ElementData
    element: FormElement
    onChange: (field: string, value: ElementDataValue) => void
}

export default function FormInputElement(props: Props) {
    const { element, data, prevData, original, onChange } = props
    const s = String(getCaseInsensitive(data, element.field!) || '')
    const formattedDate = s.substring(0, 10)
    let changed =
        getCaseInsensitive(data, element.field || '') !== getCaseInsensitive(original, element.field || '') ||
        (prevData ? getCaseInsensitive(data, element.field || '') !== getCaseInsensitive(prevData, element.field || '') : false)

    const getLabel = () => {
        if (prevData) {
            if (element.type === 'date') {
                const prevValue = String(getCaseInsensitive(prevData, element.field || ''))
                const prevFormattedDate = dayjs(new Date(prevValue.substring(0, 10))).format('YYYY-MM-DD')
                if (dayjs(new Date(prevFormattedDate)).isValid()) {
                    return prevFormattedDate + ' → ' + formattedDate
                }
                return prevValue + ' → ' + formattedDate
            }
            return getCaseInsensitive(prevData, element.field || '') + ' → ' + getCaseInsensitive(data, element.field || '')
        }
    }

    return (
        <div className='mt-2'>
            <label className='font-bold text-blue-700 flex flex-row items-center border'>
                {element.label || element.field}
                {element.required && <span className='text-red-300 mx-1'>*</span>}
                {!element.readonly && <ChangeIndicator changed={changed} />}
                {changed && prevData && (
                    <Tooltip align='bottom' label={getLabel()}>
                        <span className='cursor-pointer ml-1 flex flex-row items-center'>
                            <Information />
                        </span>
                    </Tooltip>
                )}
            </label>
            <div>
                {element.type === 'date' ? (
                    element.readonly ? (
                        <input
                            type='text'
                            value={formattedDate}
                            readOnly
                            style={{ borderColor: '#ADB0B3' }}
                        />
                    ) : (
                        <DatePicker
                            datePickerType='single'
                            value={formattedDate || undefined}
                            dateFormat='Y-m-d'
                        >
                            <DatePickerInput
                                placeholder='YYYY-MM-DD'
                                hideLabel
                                labelText={element.label}
                                id={element.type + element.field}
                                size='md'
                                style={{ borderColor: changed ? 'Highlight' : '#ADB0B3' }}
                                onInput={(e) => {
                                    const inputValue = (e.target as HTMLInputElement).value
                                    onChange(element.field!, inputValue || null)
                                }}
                            />
                        </DatePicker>
                    )
                ) : (
                    <input
                        type={element.type}
                        value={String(getCaseInsensitive(data, element.field!) || '')}
                        onChange={(e) => onChange(element.field!, e.target.value)}
                        style={{ borderColor: changed ? 'Highlight' : '#ADB0B3' }}
                        readOnly={element.readonly}
                    />
                )}
            </div>
        </div>
    )
}
